import { createContext } from '@lit/context';
import type { User, Session } from '@supabase/supabase-js';
import type { UserRole } from '../types/database';

// Auth state interface
export interface AuthState {
  user: User | null;
  session: Session | null;
  role: UserRole | null;
  loading: boolean;
  error: string | null;
}

// Initial auth state
export const initialAuthState: AuthState = {
  user: null,
  session: null,
  role: null,
  loading: true,
  error: null,
};

// Create Lit context for auth state
export const authContext = createContext<AuthState>('auth');
